import React from 'react';

declare global {
  interface Window {
    current_confirm?: () => void;
    current_cancel?: () => void;
  }
}

interface ConfirmDialogProps {
  text: React.ReactNode;
  hide: () => void;
  on_confirm: () => void;
  on_cancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

export default class ConfirmDialog extends React.Component<ConfirmDialogProps> {
  handleConfirmClick: () => void;
  handleCancelClick: () => void;

  constructor(props: ConfirmDialogProps) {
    super(props);

    this.handleConfirmClick = window.current_confirm = () => {
      this.props.hide();
      this.props.on_confirm();
    };

    this.handleCancelClick = window.current_cancel = () => {
      this.props.hide();
      this.props.on_cancel();
    };
  }

  render() {
    return (
      <div className="dialog">
        <div className="dialog-text">{this.props.text}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div
            id="dialog-confirm"
            className="button primary-button"
            onClick={this.handleConfirmClick}
          >
            <span className="no-select">
              {this.props.confirmLabel ?? 'Yes'}
            </span>
          </div>
          <div
            id="dialog-cancel"
            className="button tertiary-button"
            onClick={this.handleCancelClick}
          >
            <span className="no-select">
              {this.props.cancelLabel ?? 'Cancel'}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
